export function UserIdCardIcon({ className }: { className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M7.49988 11.0335C8.42035 11.0335 9.16654 10.2873 9.16654 9.36686C9.16654 8.44639 8.42035 7.7002 7.49988 7.7002C6.5794 7.7002 5.83321 8.44639 5.83321 9.36686C5.83321 10.2873 6.5794 11.0335 7.49988 11.0335ZM7.49988 11.0335C8.58839 11.0335 9.51438 11.7292 9.85758 12.7002M7.49988 11.0335C6.41136 11.0335 5.48529 11.7292 5.14209 12.7002M12.4999 8.53353H14.9999M12.4999 11.8669H14.1665" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      <rect x="2" y="4" width="16" height="12" rx="2" stroke="#101828" stroke-width="1.67" />
    </svg>
  );
}

export const displayName = "UserIdCardIcon";
